import { render, staticRenderFns } from "./MessageCreate.vue?vue&type=template&id=72a0808d"
import script from "./MessageCreate.vue?vue&type=script&lang=ts"
export * from "./MessageCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports